<template>
	<!-- content -->
	<div id="content" class="content goods">
		<div class="container">
			<div class="detail-title">
				<div class="inner">
					<div class="thumb-box" v-if="goodsVO.thumbnail !== null" :style="'background-image:url(' + APIs.SHOP_FILE_SHOW + goodsVO.thumbIdx + ');'"></div>
					<div class="thumb-box" v-else style="background-image:url(public/ssflex/assets/hws-images/icons8-color-64.png);"></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim">{{ goodsVO.cateVO.codeName }}</span>
							<span class="sec" v-if="goodsVO.isImport">추천상품</span>
						</div>
						<h3 class="tit">{{ goodsVO.title }}</h3>
						<div class="info">
							<div class="info-row">
								<strong>적립 포인트</strong>
								<div>{{ goodsVO.savePoint }}</div>
							</div>
							<div class="info-row">
								<strong>할인율</strong>
								<div>{{ goodsVO.eventPer }}%</div>
							</div>
						</div>
						<div class="price" style="float: left;">
							{{ totalPrice | currency }} <span class="unit">원</span>
						</div>
						<div style="text-decoration : line-through; float: left; color: silver;" class="sale-price" v-if="goodsVO.eventPer > 0">
							{{ salePriceBeforeDiscount | currency }} <span class="unit">원</span>
						</div>
						<div class="text-vat" v-if="goodsVO.isVat">
							* 부가세 포함
						</div>
						<!-- 선택한 옵션 목록 (가격 밑) -->
						<div class="selected-options-summary" v-if="selectedOptionsSummary.length > 0">
							<strong>선택 옵션</strong>
							<ul>
								<li v-for="(line, idx) in selectedOptionsSummary" :key="idx">{{ line }}</li>
							</ul>
						</div>
						<div style="float: right;" v-if="goodsVO.selling && goodsVO.stock">
							<span class="btns-added"></span>
							<input type="button" value="-" class="countMinusTempCss" @click="count > 1 ? --count : count">
<!--							<input type="number" class="inpTempCss" id="quantity" name="quantity" title="수량" size="4" oninput="this.value = this.value.replaceAll(/\D/g, '');" step="1" v-model="count">-->
							<input type="number" class="inpTempCss" id="quantity" name="quantity" title="수량" size="4" min="1" oninput="this.value = this.value.replaceAll(/\D/g, '');" step="1" v-model="count">
							<input type="button" value="+" class="countPlusTempCss" @click="++count">

							<!-- 초기화 -->
							<a href="javascript:;" class="countBtn m-l-5 p-t-4" style="text-align: center;" @click="count = 1"><i class="fas fa-sm fa-redo align-bottom"></i></a>

						</div>

						<!-- 상품 옵션 (그룹별: 단일 선택 드롭다운 / 중복 선택 드롭다운+체크박스) -->
						<div class="option-wrap" v-if="optionGroups.length > 0 && goodsVO.selling && goodsVO.stock">
							<div class="option-row" v-for="group in optionGroups" :key="group.id">
								<label class="option-label">{{ group.groupName }} <span v-if="group.required" class="required">*</span></label>
								<!-- 단일 선택 (만기 1년/3년 등) -->
								<select
									v-if="!group.allowMultiple"
									class="option-select"
									v-model="selectedOptions[group.id]"
									:required="group.required"
								>
									<option :value="null">선택하세요</option>
									<option v-for="d in group.optionDetails" :key="d.id" :value="d.id">
										{{ d.optionName }} (+{{ d.optionPrice | currency }}원)
									</option>
								</select>
								<!-- 중복 선택 (체크박스 + 확인) -->
								<div v-else class="option-multi-wrap">
									<div class="option-multi-trigger" @click="toggleMultiDropdown(group.id)">
										<span class="option-multi-label">{{ multiSelectLabel(group) }}</span>
										<i class="fas fa-chevron-down option-multi-arrow" :class="{ open: multiDropdownOpen[group.id] }"></i>
									</div>
									<div class="option-multi-panel" v-show="multiDropdownOpen[group.id]">
										<div class="option-multi-list">
											<label v-for="d in group.optionDetails" :key="d.id" class="option-multi-item">
												<input type="checkbox" :value="d.id" v-model="multiTempCheck[group.id]">
												<span>{{ d.optionName }} (+{{ d.optionPrice | currency }}원)</span>
											</label>
										</div>
										<button type="button" class="option-multi-confirm" @click="confirmMultiOption(group.id)">확인</button>
									</div>
								</div>
							</div>
						</div>

						<!-- 정상 구매 버튼 -->
						<div class="btn-wrap" v-if="goodsVO.selling && goodsVO.stock">
							<!-- 결제하기-->
							<a class="btn-purchase" @click="goPurchase">결제하기</a>
							<!-- 장바구니-->
							<a href="javascript:;" class="btn-apply" @click="goCart">장바구니</a>
							<!-- 찜-->
							<a class="btn-like" v-if="isLogin()" type="button" :id="'eWish-'+goodsVO.gid" :data-gid="goodsVO.gid" @click="setWish"><i class="ico-heart"></i>{{ wishCount | currency }}</a>
							<a class="btn-like" v-else-if="!isLogin()" type="button" @click="loginInfo"><i class="ico-heart"></i>{{ wishCount | currency }}</a>
						</div>

						<!-- 판매중지 or 재고없음 -->
						<div class="btn-wrap" v-else>
							<template v-if="!goodsVO.selling">
								판매중지된 상품입니다.
							</template>
							<template v-if="!goodsVO.stock">
								구매가능한 재고가 없습니다.
							</template>

							<!-- 찜-->
							<a class="btn-like" v-if="isLogin()" type="button" :id="'eWish-'+goodsVO.gid" :data-gid="goodsVO.gid" @click="setWish"><i class="ico-heart"></i>{{ wishCount | currency }}</a>
							<a class="btn-like" v-else-if="!isLogin()" type="button" @click="loginInfo"><i class="ico-heart"></i>{{ wishCount | currency }}</a>
						</div>

					</div>
				</div>
			</div>
			<div class="detail-content">
<!--				<div class="inner" style="word-break: break-all;" v-html="goodsVO.contentVO.contentHtml"></div>-->
				<html-open :html-code="goodsVO.contentVO.contentHtml"></html-open>
			</div>
			<div class="btn-area">
				<a href="javascript:;" class="btn-listgo" v-if="prevAddress !== -1" @click="doCancel">목록으로</a>
				<a href="javascript:;" class="btn-listgo" v-else @click="doCancel">뒤로가기</a>
			</div>
		</div>
	</div>
</template>

<script>
import wish from "@/commons/mixins/wish"
import HtmlOpen from "@/components/display/htmlOpen";

export default {
	name: "goodsDetail",
	components: {HtmlOpen},
	mixins: [
		wish
	],
	data() {
		var prevAddress;
		return {
			goodsVO: {},
			prevAddress,
			count: 1,
			optionGroups: [],
			selectedOptions: {}, // groupId -> single: detailId, multi: [detailId, ...]
			multiDropdownOpen: {}, // groupId -> boolean
			multiTempCheck: {},   // groupId -> array of detailIds (체크박스용)
		}
	},
	computed: {
		// 선택한 옵션들의 추가가격 합계 (단일/다중 모두 반영)
		selectedOptionPriceSum() {
			let sum = 0
			this.optionGroups.forEach(group => {
				const val = this.selectedOptions[group.id]
				const ids = Array.isArray(val) ? val : (val != null ? [val] : [])
				ids.forEach(detailId => {
					const detail = (group.optionDetails || []).find(d => d.id === detailId)
					if (detail && detail.optionPrice != null && detail.optionPrice !== '') {
						sum += Number(detail.optionPrice) || 0
					}
				})
			})
			return sum
		},
		// 가격 밑 표시용: 선택한 옵션 요약 문자열 배열
		selectedOptionsSummary() {
			const lines = []
			this.optionGroups.forEach(group => {
				const val = this.selectedOptions[group.id]
				const ids = Array.isArray(val) ? val : (val != null ? [val] : [])
				if (ids.length === 0) return
				const names = ids.map(detailId => {
					const d = (group.optionDetails || []).find(x => x.id === detailId)
					return d ? d.optionName + (d.optionPrice && Number(d.optionPrice) !== 0 ? ' (+' + (d.optionPrice != null ? this.$options.filters.currency(d.optionPrice) : '') + '원)' : '') : ''
				}).filter(Boolean)
				if (names.length) lines.push(group.groupName + ': ' + names.join(', '))
			})
			return lines
		},
		// (상품 기본가 + 선택 옵션 총가) * 수량
		totalPrice() {
			const base = Number(this.goodsVO.basePrice) || 0
			return (base + this.selectedOptionPriceSum) * this.count
		},
		// 할인 전 가격 (eventPer 적용 시 취소선용)
		salePriceBeforeDiscount() {
			if (!this.goodsVO.eventPer || this.goodsVO.eventPer <= 0) return this.totalPrice
			return Math.floor(-1 * (this.totalPrice / ((this.goodsVO.eventPer / 100) - 1)))
		},
	},
	created() {
		this.getGoodsOne()
	},
	mounted() {
		this.prevAddress = (document.referrer).indexOf('design_auto_app');
	},
	methods: {
		getGoodsOne() {
			console.log('getGoodsOne')
			var gid = this.$route.params.gid

			this.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get(this, this.APIs.SHOP_GOODS + "/" + gid, {}, (res) => {
				var result = res.data
				this.goodsVO = result.goods
				this.$eventBus.$emit("doneProgress", 1)
				this.getOptionGroups(gid)
				console.log('goodsVO : ', result.goods)
			})
		},

		getOptionGroups(gid) {
			this.axiosCaller.get(this, this.APIs.SHOP_GOODS + "/" + gid + "/options", {}, (res) => {
				var result = res.data
				if (result.status === "ok" && result.list) {
					this.optionGroups = result.list
					this.selectedOptions = {}
					this.multiDropdownOpen = {}
					this.multiTempCheck = {}
					this.optionGroups.forEach(g => {
						const defaultDetails = (g.optionDetails || []).filter(d => d.defaultOption === true)
						if (g.allowMultiple) {
							const defaultIds = defaultDetails.map(d => d.id)
							this.$set(this.selectedOptions, g.id, defaultIds)
							this.$set(this.multiTempCheck, g.id, defaultIds)
						} else {
							const firstDefault = defaultDetails[0]
							this.$set(this.selectedOptions, g.id, firstDefault ? firstDefault.id : null)
						}
						this.$set(this.multiDropdownOpen, g.id, false)
						if (!g.allowMultiple) {
							this.$set(this.multiTempCheck, g.id, [])
						}
					})
				}
			})
		},

		toggleMultiDropdown(groupId) {
			const next = !this.multiDropdownOpen[groupId]
			// 다른 그룹 드롭다운은 닫기
			this.optionGroups.forEach(g => {
				this.$set(this.multiDropdownOpen, g.id, g.id === groupId && next)
			})
			if (next) {
				const current = this.selectedOptions[groupId]
				const ids = Array.isArray(current) ? [...current] : (current != null ? [current] : [])
				this.$set(this.multiTempCheck, groupId, ids)
			}
		},
		multiSelectLabel(group) {
			const val = this.selectedOptions[group.id]
			const ids = Array.isArray(val) ? val : (val != null ? [val] : [])
			if (ids.length === 0) return '선택하세요'
			if (ids.length === 1) {
				const d = (group.optionDetails || []).find(x => x.id === ids[0])
				return d ? d.optionName + (d.optionPrice && Number(d.optionPrice) !== 0 ? ' (+' + (d.optionPrice != null ? this.$options.filters.currency(d.optionPrice) : '') + '원)' : '') : '선택하세요'
			}
			return ids.length + '개 선택됨'
		},
		confirmMultiOption(groupId) {
			this.$set(this.selectedOptions, groupId, [...(this.multiTempCheck[groupId] || [])])
			this.$set(this.multiDropdownOpen, groupId, false)
		},

		async goCart() {

			if ( !await this.requireLogin(this) ) {
				return
			}

			var gid = this.$route.params.gid;
			var userId = this.getSessionProc().coEmailId;
			var count = this.count;
			const optionDetailIds = [];
			this.optionGroups.forEach(group => {
				const val = this.selectedOptions[group.id]
				if (Array.isArray(val)) val.forEach(id => { if (id != null && id !== '') optionDetailIds.push(id) })
				else if (val != null && val !== '') optionDetailIds.push(val)
			})

			this.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.post(this, this.APIs.CART + "/setCart", {
				gid: gid,
				coEmailId: userId,
				count: count,
				optionDetailIds: optionDetailIds.length > 0 ? optionDetailIds : undefined,
			}, (res) => {
				var result = res.data
				if (result.status === "ok") {
					this.swalUtils.fire("장바구니로 이동하시겠습니까?", "선택하신 상품이\r\n장바구니에 추가되었습니다.", "info", true)
							.then((result) => {
								if (result.isConfirmed) { location.href = "/app/shop/cartList" }
							})
				} else {
					this.swalUtils.fire("비정상적인 접근", "메인으로 이동합니다.", "error", true, true)
							.then((result) => {
								console.log( result )
							});
				}
			})
		},

		loginInfo() {
			this.swalUtils.fire("로그인 후 사용가능합니다.",  "로그인 화면으로 이동합니다.", "info", true)
					.then((result) => {
						let pathname = location.pathname;
						let referrer = ("?referrer=" + encodeURIComponent( pathname ));
						if (result.isConfirmed) { location.href = "/member/login" + referrer }
					})
		},

		doCancel() {
			history.back();
			return;
		},

		async goPurchase() {

			if ( !await this.requireLogin(this) ) {
				return
			}

			// 필수 옵션 미선택 시 알림
			for (const group of this.optionGroups) {
				if (!group.required) continue
				const val = this.selectedOptions[group.id]
				const hasSelection = Array.isArray(val) ? (val.length > 0) : (val != null && val !== '')
				if (!hasSelection) {
					const name = group.groupName || '옵션'
					this.swalUtils.fire('필수 옵션을 선택해 주세요', `"${name}"을(를) 선택해 주세요.`, 'warning', false)
					return
				}
			}

			const gid = this.$route.params.gid
			const count = this.count
			const optionDetailIds = []
			this.optionGroups.forEach(group => {
				const val = this.selectedOptions[group.id]
				if (Array.isArray(val)) val.forEach(id => { if (id != null && id !== '') optionDetailIds.push(id) })
				else if (val != null && val !== '') optionDetailIds.push(val)
			})
			const optionQuery = optionDetailIds.length > 0 ? '&optionDetailIds=' + optionDetailIds.join(',') : ''

			this.swalUtils.fire("선택하신 상품을\r\n구매하시겠습니까?", "", "info", true)
					.then((result) => {
						this.$eventBus.$emit("startProgress", 1)
						if (result.isConfirmed) {
							location.href = "/app/shop/order_info?gidx=" + gid + "&count=" + count + optionQuery
						//
						// 	var gid = this.$route.params.gid
						// 	var userId = this.getSessionProc().coEmailId;
						// 	var count = this.count;
						// 	this.axiosCaller.post(this, this.APIs.CART + "/setCart", {
						// 		gid: gid,
						// 		coEmailId: userId,
						// 		count: count
						// 	}, (res) => {
						// 		var result = res.data
						// 		if (result.status === "ok") {
						// 			location.href = "/app/shop/order_info?gidx="+this.gid+"&count="+this.count
						// 		} else {
						// 			this.swalUtils.gritter("Error", result.msg, "error")
						// 					.then(() => {
						// 						location.href = document.referrer
						// 					})
						// 		}
						// 	})
						//
						}
					})
		}

	},
	watch: {}
}
</script>

<style scoped>
.option-wrap {
	clear: both;
	width: 100%;
	margin-bottom: 16px;
}
.option-row {
	margin-bottom: 12px;
}
.option-label {
	display: block;
	margin-bottom: 4px;
	font-weight: 600;
}
.option-label .required {
	color: var(--secondary, #e84c4c);
}
.option-select {
	width: 100%;
	max-width: 280px;
	padding: 8px 12px;
	border: 1px solid var(--gray100, #ddd);
	border-radius: 4px;
	font-size: 14px;
}
.option-multi-wrap {
	position: relative;
	max-width: 280px;
}
.option-multi-trigger {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 8px 12px;
	border: 1px solid var(--gray100, #ddd);
	border-radius: 4px;
	font-size: 14px;
	background: #fff;
	cursor: pointer;
	text-align: left;
}
.option-multi-label {
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: #333;
}
.option-multi-label:empty::before { content: '선택하세요'; color: #999; }
.option-multi-arrow {
	font-size: 12px;
	margin-left: 8px;
	transition: transform 0.2s;
	color: #666;
}
.option-multi-arrow.open {
	transform: rotate(180deg);
}
.option-multi-panel {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	margin-top: 4px;
	padding: 12px;
	background: #fff;
	border: 1px solid var(--gray100, #ddd);
	border-radius: 4px;
	box-shadow: 0 4px 12px rgba(0,0,0,0.1);
	z-index: 10;
}
.option-multi-list {
	max-height: 200px;
	overflow-y: auto;
	margin-bottom: 10px;
}
.option-multi-item {
	display: flex;
	align-items: center;
	padding: 6px 0;
	cursor: pointer;
	font-size: 14px;
}
.option-multi-item input {
	margin-right: 8px;
}
.option-multi-confirm {
	display: block;
	width: 100%;
	padding: 8px;
	background: var(--secondary, #e84c4c);
	color: #fff;
	border: none;
	border-radius: 4px;
	font-size: 14px;
	cursor: pointer;
}
.option-multi-confirm:hover {
	opacity: 0.9;
}
.selected-options-summary {
	clear: both;
	width: 100%;
	margin-top: 12px;
	margin-bottom: 8px;
	padding: 10px 0;
	font-size: 14px;
}
.selected-options-summary strong {
	display: block;
	margin-bottom: 6px;
}
.selected-options-summary ul {
	margin: 0;
	padding-left: 18px;
	color: #555;
}
.selected-options-summary li {
	margin-bottom: 2px;
}
.btn-purchase {
	cursor: pointer;
}
.btn-wrap .btn-like i {
	display: inline-block;
	width: 16px;
	height: 16px;
	margin-right: 8px;
	background: url(/ssflex/assets/img/common/ico_heart_prim.svg) no-repeat center/16px;
	vertical-align: middle;
}
.btn-wrap .btn-like.active i {
	background: url(/ssflex/assets/img/common/ico_heart_fill_prim.svg) no-repeat center/16px;
}
.sale-price {
	margin-left: 6px;
	margin-top: 12px;
	margin-bottom: 24px;
	font-size: 16px;
	font-weight: 900;
}
.text-vat {
	display: inline-block;
	margin-left: 6px;
	margin-top: 16px;
	margin-bottom: 24px;
	font-size: 12px;
	/*color: red;*/
}
/* goodsDetail btn */
.goods .detail-title .btn-wrap .btn-purchase {
	width: 100%;
	margin-right: 16px;
	background-color: var(--secondary);
	vertical-align: top;
	color: #fff;
	margin-bottom: 2%;
}
.inpTempCss,
.countMinusTempCss,
.countPlusTempCss {
	margin-bottom: 48px;
}
.countPlusTempCss,
.countMinusTempCss {
	position: relative;
	float: left;
	width: 28px;
	height: 28px;
	background: #fff;
	border: 1px solid var(--gray100);
	border-radius: 14px;
	font-size: 0;
	color: transparent;
}
.countBtn {
	position: relative;
	float: left;
	width: 28px;
	height: 28px;
	background: #fff;
	border: 1px solid var(--gray100);
	border-radius: 14px;
	/*font-size: 0;*/
	/*color: transparent;*/
}
.countPlusTempCss {
	background: url(/ssflex/assets/img/common/ico_add.svg) no-repeat center/16px;
}
.countMinusTempCss {
	background: url(/ssflex/assets/img/common/ico_minus.svg) no-repeat center/16px;
}
.inpTempCss {
	float: left;
	width: 40px;
	height: 28px;
	border: 0;
	text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
input[type=number] {
	-moz-appearance: textfield;
}
</style>
